import { $ } from '../bootstrap';
import { formatCurrency, getFractionDigits } from '../../utils/formatters';

const $purchase = $("#purchase");
let maxLines = 0;
let ballsPerLine = 0;
if ($purchase.length > 0) {
    maxLines = parseInt($purchase.freshData('lines'));
    ballsPerLine = parseInt(
        $purchase.freshData('ncount') +
        $purchase.freshData('bcount') +
        $purchase.freshData('tcount') +
        $purchase.freshData('fcount')
    );
}

const fractionDigits = getFractionDigits();

$('.purchase-more-pick, .purchase-more, .pick-wrapper .purchase-line-clear').click(purchaseMorePick);

$('.mobile-delete-line').click(function() {
    updateYourLines();
    hidePlayPickers();
    updateWinUpToBox();
});

function purchaseMorePick(e) {
    if (null != e) {
        e.preventDefault();
    }

    checkMobileEntities(false, !window.matchMedia('(min-width: 576px)').matches);
    checkPlayLines();
    updateYourLines();
    hidePlayPickers();
}

function updateYourLines() {
    let checked_pickers = $('.play-picker.checked').length;

    if (checked_pickers === 0) {
        if (window.matchMedia("(min-width: 576px)").matches) {
            $('.form-mobile').hide();
        } else {
            $('.form-mobile').show();
        }
    } else {
        $('.form-mobile').show();
    }

    $('#your-lines-value').html(checked_pickers);
}

$('#game-type').on('change', function (event) {
    $('.multiplier-select').hide();
    $('#multiplier-select-' + event.target.value).show().trigger('change');
    updateWinUpToBox();
});

$('.multiplier-select').on('change', function (event) {
    $('input[name="multiplier"]', '#purchase').val(event.target.value);
    calculatePrice();
    updateWinUpToBox();
});

// shows proper multiplier select for game type at beginning
$('#multiplier-select-' + $('#game-type option:selected').val()).show().trigger('change');

if (matchMedia) {
    var mobile1 = window.matchMedia("(min-width: 576px)");
    var mobile2 = window.matchMedia("(max-width: 766px)");
    var mobile3 = window.matchMedia("(max-width: 1050px)");
    var mobile4 = window.matchMedia("(max-width: 1250px)");
    var mobile5 = window.matchMedia("(max-width: 1600px)");

    mobile1.addListener(playMediaChange);
    mobile2.addListener(playMediaChange);
    mobile3.addListener(playMediaChange);
    mobile4.addListener(playMediaChange);
    mobile5.addListener(playMediaChange);

    playMediaChange(mobile1);
}

function playMediaChange(mq) {
    $('.purchase-more-pick, .purchase-more').click();
}

$('.purchase-line-chooseable.ball').on('click', function() {
    const selectedBallCount = $(this).parents('.purchase-line').find('.ball.choosed').length;

    if (selectedBallCount === ballsPerLine) {
        purchaseMorePick();
        hidePlayPickers();
        updateWinUpToBox();
    }
});

function hidePlayPickers() {
    $('.play-picker.checked').each(function(index) {
        if (index < maxLines - 1) {
            this.parentNode.classList.add('d-none');
        }
    });
}

$(document).ready(function() {
    pickSelectMultiplierForRules();

    $('.rules-collapse-text').on('click', function() {
       $('small', this).toggle();
    });
    updateWinUpToBox();
});

function pickSelectMultiplierForRules() {
    const $wrapper = $('.pick-rules-multiplier-select-wrapper');
    if (!$wrapper.length) {
        return;
    }

    const $select = $wrapper.find('#pick-rules-multiplier-select');
    const $waysToPlay = $('.ways-to-play');

    $select
        .on('change', function() {
            const multiplier = parseInt(this.value);

            $waysToPlay.each((index, item) => {
                const multipliers = JSON.parse(item.dataset.multipliers);
                const $prizeWrapper = $('.ways-to-play-prize', item);

                let prize = parseFloat($prizeWrapper.data('value'));
                prize *= multiplier;
                prize = Math.round(prize * 100) / 100;
                const lotteryCurrencyElement = document.getElementById('lottery-local-currency');
                const currency = lotteryCurrencyElement
                    ? lotteryCurrencyElement.getAttribute('data-lottery-local-currency')
                    : '';
                const text = formatCurrency(prize, fractionDigits, currency);

                $prizeWrapper.text(text);

                if (multipliers.indexOf(multiplier) > -1) {
                    item.classList.add('d-block');
                    item.classList.remove('d-none');

                    const $playButton = $('.btn-play', item);
                    if ($playButton.length > 0) {
                        const href = new URL($playButton.attr('href'));

                        if (href.searchParams.has('multiplier')) {
                            href.searchParams.set('multiplier', multiplier);
                        } else {
                            href.searchParams.append('multiplier', multiplier);
                        }

                        $playButton.attr('href', href);
                    }
                } else {
                    item.classList.add('d-none');
                    item.classList.remove('d-block');
                }
            });
        })
        .trigger('change');
}


function updateWinUpToBox() {
    let $winUpToCard = $('.win-up-to-card');
    let $winUpToAmount = $winUpToCard.find('.win-up-to-amount');

    if (!$winUpToCard.length || typeof lotteryMaxPrizes == 'undefined') {
        return;
    }

    const selectedGameType = $('#game-type option:selected').val();

		let prize = Object.entries(lotteryMaxPrizes)
			.map((item) => item[1][0])
			.filter((item) => item.slug === selectedGameType)[0].prize;

    let multiplier= parseFloatAlt($('input[name=multiplier]:checked', '#purchase').val());
    if (!isNaN(multiplier)) {
        prize *= multiplier;
    }

    let numberOfLines = $('.play-picker.checked').length;
    if (numberOfLines === 0) {
        // If there is no selected lines we will display prize for single line
        numberOfLines = 1;
    }
    prize *= numberOfLines;
    prize = formatCurrency(prize, fractionDigits);

    $winUpToAmount.text(prize);
}

// Hide mobile box when user unselect ball
$('.purchase-line-container .ball').on('click', function() {
    const $container = $(this).parents('.purchase-line-container');
    const index = $container.data('i') + 1;
    const selectedBalls = $container.find('.ball.choosed').length;

    if (index === maxLines && selectedBalls < ballsPerLine) {
        $(`[class*="purchase-line-container-mobile"][data-i="${index - 1}"]`)
            .removeClass('mobile-picker-checked')
            .addClass('d-none');
        updateWinUpToBox();
    }
});

function parseFloatAlt(val) {
    if (isNaN(val)) {
        if ((val = val.match(/([0-9\.,]+\d)/g))) {
            val = val[0].replace(/[^\d\.]+/g, '')
        }
    }
    return parseFloat(val)
}
